import { toast } from "react-toastify";

export const downloadSampleFile = async (type: string, setSampleDownloading: Function, accessSessionTokenKeyName, platform?: string, ) => {
            setSampleDownloading(true)
            console.log({platform, type});
            if (platform === "SHIPHERO" || platform === "CDON") {
                let fileUrl = "";
                let fileName = "";

                if (platform === "SHIPHERO") {
                    fileUrl =
                    "https://commercium.s3.us-east-2.amazonaws.com/sample_files/shiphero_shipping_method.csv";
                    fileName = "shiphero_shipping_method.csv";
                } else if (platform === "CDON") {
                    fileUrl =
                    "https://commercium.s3.us-east-2.amazonaws.com/sample_files/sample_CDON_products.csv";
                    fileName = "sample_CDON_products.csv";
                }

                const a = document.createElement("a");
                a.href = fileUrl;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                setSampleDownloading(false);
                }else{
                fetch(`${process.env.REACT_APP_API_URL}/api/download/${type}.csv`,{
                    method:"GET",
                    redirect:'follow',
                    headers:{
                        Accept: 'text/csv,application/octet-stream,*/*',
                        'Authorization' : `Bearer ${accessSessionTokenKeyName}`
                    }
                })
                .then((res)=>{
                    if (!res.ok) {
                        throw new Error(`Download failed with status ${res.status}`)
                    }
                    return res.blob()
                })
                .then((result)=>{
                    console.log('result', result)
                    var url = window.URL.createObjectURL(result);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = `sample_${type}.csv`;
                    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                    a.click();    
                    a.remove();  //afterwards we remove the element again
                    window.URL.revokeObjectURL(url);
                    setSampleDownloading(false)
                    toast.success('Sample file downloaded successfully')  
                })
                .catch((err)=>{
                    console.log('err', err)
                    toast.warning('Unable to download sample file.'+err)
                    setSampleDownloading(false)  
                })
            }
    }


